export default "__VITE_ASSET__CFdWrI9Z__"